import { render } from "./Dashboard.vue?vue&type=template&id=5db0f245&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=5db0f245&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db0f245"]])

export default __exports__